import type { IndiceLink, SecaoDocumento } from "./models";

export function buildIndiceItems(
  obrigatorios: SecaoDocumento[],
  bonus: SecaoDocumento[],
  bonusExtra: SecaoDocumento[],
  pendenciasObrigatorios: Record<string, boolean>,
  pendenciasBonus: Record<string, boolean>,
  pendenciasBonusExtra: Record<string, boolean>,
  destaqueAlteracaoPorSecaoId?: Record<string, boolean>,
  adequacaoSolicitadaPorSecaoId?: Record<string, boolean>,
  adequacaoAguardandoPorSecaoId?: Record<string, boolean>,
  adequacaoRespondidaPorSecaoId?: Record<string, boolean>,
  parecerAnalistaPorSecaoId?: Record<string, string | undefined>,
): { title: string; links: IndiceLink[] }[] {
  const dest = destaqueAlteracaoPorSecaoId;
  const adq = adequacaoSolicitadaPorSecaoId;
  const adqAguard = adequacaoAguardandoPorSecaoId;
  const adqResp = adequacaoRespondidaPorSecaoId;
  const parecer = parecerAnalistaPorSecaoId;
  const statusAnalistaPorSecao = (secaoId: string): string =>
    String(parecer?.[secaoId] ?? "");
  const manterDestaqueAdequacaoRespondida = (secaoId: string): boolean => {
    const adequacaoRespondida = adqResp?.[secaoId] ?? false;
    if (!adequacaoRespondida) return false;
    return statusAnalistaPorSecao(secaoId) === "DEVOLVER";
  };
  const manterBadgeAdequacaoSolicitada = (secaoId: string): boolean => {
    const solicitada = adq?.[secaoId] ?? false;
    if (!solicitada) return false;
    const adequacaoRespondida = adqResp?.[secaoId] ?? false;
    if (!adequacaoRespondida) return true;
    return statusAnalistaPorSecao(secaoId) === "DEVOLVER";
  };
  const resolveIsPending = (
    secaoId: string,
    pendencias: Record<string, boolean>,
  ): boolean => {
    const statusAnalista = statusAnalistaPorSecao(secaoId);
    const adequacaoRespondida = adqResp?.[secaoId] ?? false;
    if (
      adequacaoRespondida &&
      (statusAnalista === "" ||
        statusAnalista === "CONFORME" ||
        statusAnalista === "NAO_CONFORME")
    ) {
      return false;
    }
    const pendente = pendencias[secaoId] ?? true;
    if (pendente) return true;
    // No índice, o estado pendente definido pelo analista tem prioridade
    // sobre o badge de "adequação respondida" do histórico.
    return false;
  };
  return [
    {
      title: "DOCUMENTOS OBRIGATÓRIOS",
      links: obrigatorios.map((s) => ({
        tabKey: "doc-obrigatorios",
        id: s.id,
        label: s.titulo,
        isPending: resolveIsPending(s.id, pendenciasObrigatorios),
        isDestaqueAlteracao: dest?.[s.id] ?? false,
        isAdequacaoSolicitada: manterBadgeAdequacaoSolicitada(s.id),
        isAdequacaoAguardando: adqAguard?.[s.id] ?? false,
        isAdequacaoRespondida: manterDestaqueAdequacaoRespondida(s.id),
      })),
    },
    {
      title: "DOCUMENTOS BÔNUS",
      links: bonus.map((s) => ({
        tabKey: "doc-bonus",
        id: s.id,
        label: s.titulo,
        isPending: resolveIsPending(s.id, pendenciasBonus),
        isDestaqueAlteracao: dest?.[s.id] ?? false,
        isAdequacaoSolicitada: manterBadgeAdequacaoSolicitada(s.id),
        isAdequacaoAguardando: adqAguard?.[s.id] ?? false,
        isAdequacaoRespondida: manterDestaqueAdequacaoRespondida(s.id),
      })),
    },
    {
      title: "DOC. BÔNUS EXTRA",
      links: bonusExtra.map((s) => ({
        tabKey: "doc-bonus-extra",
        id: s.id,
        label: s.titulo,
        isPending: resolveIsPending(s.id, pendenciasBonusExtra),
        isDestaqueAlteracao: dest?.[s.id] ?? false,
        isAdequacaoSolicitada: manterBadgeAdequacaoSolicitada(s.id),
        isAdequacaoAguardando: adqAguard?.[s.id] ?? false,
        isAdequacaoRespondida: manterDestaqueAdequacaoRespondida(s.id),
      })),
    },
  ];
}

